// src/screens/MarketplaceScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  IoHomeOutline,
  IoStorefrontOutline,
  IoWalletOutline,
  IoSettingsOutline,
  IoWarningOutline,
  IoChatbubblesOutline,
  IoMegaphoneOutline,
  IoCashOutline,
  IoPeopleOutline,
  IoLogOutOutline,
} from 'react-icons/io5';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import * as Ionicons from 'react-icons/io5';
import './MarketplaceScreen.css';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import BotonPanico from '../components/Safety/BotonPanico';

// Dinamic Icon Renderer Helper
const renderIcon = (iconName, size = 28) => {
  const IconComponent = Ionicons[iconName] || Ionicons['IoEllipsisHorizontalCircleOutline'];
  return <IconComponent size={size} />;
};

function MarketplaceScreen() {
  const navigate = useNavigate();
  const { userData, logout } = useAuth();
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'marketplace_categorias'), where('activo', '==', true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = [];
      snapshot.forEach(doc => data.push({ idDoc: doc.id, ...doc.data() }));
      data.sort((a, b) => (a.orden || 0) - (b.orden || 0));
      setCategorias(data);
      setLoading(false);
    }, (error) => {
      console.error("Error cargando categorías:", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try { await logout(); navigate('/login'); } catch (e) { console.error(e); }
  };

  return (
    <div className="ks-page">
      {/* ── DESKTOP SIDEBAR ─────────────────────── */}
      <KondoSidebar activeRoute="/marketplace" />

      {/* ── MAIN AREA ────────────────────────────── */}
      <main className="ks-main">
        <div className="ks-scroll-area">
          <div className="ks-marketplace-header-sticky-wrapper">
            <KondoBrandHeader showBack={false} />
          </div>

          <div className="marketplace-content-wrapper">
            <div className="marketplace-header-stitch">
              <div className="muro-hero-card">
                <div className="muro-hero-content">
                  <h1>Marketplace</h1>
                  <p>Encuentra lo que necesitas para tu hogar.</p>
                </div>
                <IoStorefrontOutline className="muro-hero-icon-decor" />
              </div>
            </div>

            <div className="marketplace-section-title">
              Explorar Categorías
            </div>

            <div className="marketplace-grid compact">
              {loading ? (
                <p style={{ textAlign: 'center', width: '100%', color: '#64748b' }}>Cargando rubros...</p>
              ) : categorias.map(cat => (
                <div
                  key={cat.idDoc}
                  className="service-card-compact"
                  onClick={() => navigate(`/marketplace/lista/${cat.nombre.toLowerCase()}`)}
                  style={cat.color ? { borderColor: `${cat.color}30` } : {}}
                >
                  <div className="service-icon-compact" style={cat.color ? { color: cat.color, background: `${cat.color}15` } : {}}>
                    {renderIcon(cat.iconoNombre)}
                  </div>
                  <h3>{cat.nombre}</h3>
                </div>
              ))}
            </div>

            <div style={{ padding: '0 16px', marginTop: '24px' }}>
              <div 
                onClick={() => navigate('/marketplace/mis-cotizaciones')}
                style={{
                  background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                  border: '1px solid #bfdbfe',
                  borderRadius: '24px',
                  padding: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(37, 99, 235, 0.05)',
                  transition: 'all 0.2s'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{
                    background: '#3b82f6',
                    color: 'white',
                    width: '48px',
                    height: '48px',
                    borderRadius: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <IoStorefrontOutline size={24} />
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', fontWeight: '800', color: '#1e3a8a', fontFamily: "'Manrope', sans-serif", textAlign: 'left' }}>
                      Mis Servicios Contratados
                    </h3>
                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#2563eb', fontWeight: '500', textAlign: 'left', lineHeight: '1.4' }}>
                      Revisa tu historial, estados y solicita garantías.
                    </p>
                  </div>
                </div>
                <div style={{ color: '#2563eb', fontWeight: '800', fontSize: '1.4rem', paddingLeft: '10px' }}>
                  →
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
        <KondoBottomNav activeRoute="/marketplace" />
      </main>
    </div>
  );
}

export default MarketplaceScreen;